import React from 'react'
import { IconContainer, IconText } from '../../../ATS/style'
import { AllowButton } from '../../../ATS/Components/IndividualTable/Style'
import ShortlistIcon from 'components/icons/DriveTableIcon/Shortlist'
import RejectIcon from 'components/icons/DriveTableIcon/Reject'
import { StyledButton1 } from '../style'
export default function SelectIcon({
  currentTab,
  handleStatusClick,
  selectedCandidateId,
  isPaid,
  setIsPaid,
  setPageNumber
}) {
  const isDisabled = selectedCandidateId.length === 0

  return (
    <IconContainer>
      {currentTab == 'REGISTER' && (
        <>
         <StyledButton1
            onClick={() => 
              {
                setPageNumber(0);
                setIsPaid(!isPaid);
              }}
            isSelected={!isPaid}
          >
             Unpaid
          </StyledButton1>
          <StyledButton1 onClick={() => 
            {
              setPageNumber(0);
            setIsPaid(!isPaid);
          }}
           isSelected={isPaid}>
            Paid
          </StyledButton1>
         
        </>
      )}
          {currentTab == 'REGISTER' && (
      <IconText>Select status</IconText>
          )}
      {((!isPaid && currentTab == 'REGISTER')) && (
        <AllowButton
          onClick={() => (isDisabled ? '' : handleStatusClick(1))}
          disabled={isDisabled}
        >
          <ShortlistIcon title="Paid" />
        </AllowButton>
      )}
      {((isPaid && currentTab == 'REGISTER')) && (
        <AllowButton
          onClick={() => (isDisabled ? '' : handleStatusClick(0))}
          disabled={isDisabled}
        >
          <RejectIcon title="Unpaid" />
        </AllowButton>
      )}
    </IconContainer>
  )
}
